module.exports = __webpack_public_path__ + "img/intermediate.bda00b16.png";